import { useQuery } from "@tanstack/react-query";
import { useRef } from "react";
import { getHospitals } from "@features/hospitals/context/ChangeActiveHospitalModal/utils";
import { queryKeys } from "@lib/queryKeys";

export const useHospitalList = (userId: number, enabled = true) => {
  const getHospitalsRequestRef = useRef<AbortController | null>(null);

  return useQuery({
    queryKey: queryKeys.hospitals.activeList(userId),
    queryFn: async () => {
      getHospitalsRequestRef.current?.abort();
      getHospitalsRequestRef.current = new AbortController();

      return getHospitals(getHospitalsRequestRef.current.signal);
    },
    enabled,
    refetchOnWindowFocus: false,
    retry: false,
    staleTime: 6 * 60 * 60 * 1000,
  });
};
